import React from 'react'
import './App.css'
import Queries from './GraphQl/Queries.tsx'

export default function App() {

    
    return(

            <section>
                <header>
                    <h1>Countries Catalog</h1>
                </header>
                <Queries/>
            </section>
        
    )


    
}



